import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { Stripe } from './stripe.model';

export const CARD_PAYMENTS_SCHEMA = Object.freeze({
  STRIPE: Stripe,
});
const RECORD = generateSchema(CARD_PAYMENTS_SCHEMA);
const KEYS: any = generateKeys(CARD_PAYMENTS_SCHEMA);

export class CardPayments extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    return setInModel(this, [
      {
        key: KEYS.STRIPE,
        value: new Stripe(this.stripe),
      },
    ]) as CardPayments;
  }

  get stripe(): Stripe {
    return this.get(KEYS.STRIPE);
  }
}
